import Model from './Model';

import GetPageSettingResponse from 'Api/CRM/Responses/PageSettingResponse';

export default class PageSetting extends Model {
    readonly id: number;
    readonly key: string;
    readonly value: string;
    readonly updated_at: string;
    readonly created_at: string;

    constructor(menu: Partial<GetPageSettingResponse>) {
        super();
        this.assignDataToProps(menu, ['id', 'key', 'value', 'created_at', 'updated_at']);
    }
}
